<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { usePlayer } from '@/composables/usePlayer';
import { useLimitsStore } from '@/stores';
import LimitExceedModal from './LimitExceedModal.vue';
const { player } = usePlayer();
const limitsStore = useLimitsStore();
const visible = ref(false);
const limitsStoreFlag = computed(() => limitsStore.limitsModal.depositFlag);

function toCloseModal() {
    limitsStore.toSetLimitsData(
        {
            modal: false
        },
        'depositFlag'
    );
    visible.value = false;
}

const depositLimitData = computed(() => {
    return {
        limit_type: 'deposit',
        title: 'deposit_limit_title',
        description: 'deposit_limit_description',
        close_button_text: 'close',
        is_close_game: false,
        limit_amount: limitsStoreFlag.value.value,
        start_date: limitsStoreFlag.value.start_date || null,
        image: 'deposit',
        end_date: limitsStoreFlag.value.end_date || null,
        player: player.value
    };
});

watch(
    () => limitsStoreFlag.value,
    (newVal) => {
        if (newVal && newVal.modal) {
            visible.value = true;
        } else {
            visible.value = false;
        }
    },
    { immediate: true }
);
</script>
<template>
    <LimitExceedModal v-model:visible="visible" :data="depositLimitData" @update:visible="toCloseModal"></LimitExceedModal>
</template>
